import { render, staticRenderFns } from "./registerTwo.vue?vue&type=template&id=468ea5b2&scoped=true&"
import script from "./registerTwo.vue?vue&type=script&lang=js&"
export * from "./registerTwo.vue?vue&type=script&lang=js&"
import style0 from "./registerTwo.vue?vue&type=style&index=0&id=468ea5b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468ea5b2",
  null
  
)

export default component.exports